<template>
    <span>
        <button
            type="button"
            class="btn btn-sm is-primary"
            @click="$modal.show(`change-email-account-password-${emailAccount.id}`)"
        >
            {{ lang('Byt lösenord','Change password') }}
        </button>

        <form-modal
            :title="lang('Byt lösenord','Change password')"
            :name="`change-email-account-password-${emailAccount.id}`"
            method="patch"
            :action="route('front.my-pages.api.email-accounts-password.update', emailAccount)"
            :redirect-to="route('front.my-pages.broadband.index')"
            :primary-button-text="lang('Spara','Save')"
            :close-button-text="lang('Avbryt','Cancel')"
        >
            <div>
                <div class="flex flex-col md:flex-row mb-lg">
                    <div class="w-full md:mr-`lg">
                        <password-input
                            :label="lang('Nytt lösenord','New password')"
                            name="password"
                            :required="true"
                            :autofocus="true"
                        />
                    </div>

                    <div class="w-full md:ml-lg">
                        <text-input
                            :label="lang('Bekräfta lösenord','Confirm password')"
                            type="password"
                            name="password_confirmation"
                            :required="true"
                        />
                    </div>
                </div>
            </div>
        </form-modal>
    </span>
</template>

<script>
    export default {
        props: {
            emailAccount: {
                type: Object,
                required: true,
            },
        },
    };
</script>